import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Paragraph from 'components/atoms/Paragraph';
import Heading from 'components/atoms/Heading';
import { Link } from 'react-router-dom';
import CloudIcon from 'assets/icons/cloudIcon.png';
import { gsap } from 'gsap';
import {
  Wrapper,
  Nav,
  NavItem,
  StyledCloudIcon,
  StyledAgendaIcon,
  StyledNotesIcon,
  PageTitle,
  StyledAgendaIconBig,
  StyledNotesIconBig,
  AdditionalContent,
} from './Topbar.styles';

const Topbar = ({ favicon, title, additionalContent }) => {
  const navItemsRef = useRef(null);

  const [isNavItemHidden, setIsNavItemHidden] = useState(false);

  useEffect(() => {
    document.title = title;
    const f = document.getElementById('favicon');
    f.href = favicon;
  }, []);

  useEffect(() => {
    setTimeout(() => {
      if (navItemsRef.current) {
        gsap
          .timeline()
          .to(navItemsRef.current.children, {
            stagger: 0.5,
            width: 51,
          })
          .call(
            () => {
              setIsNavItemHidden(true);
            },
            null,
            0,
          );
      }
    }, 10 * 1000);
  }, []);

  return (
    <Wrapper>
      <Nav ref={navItemsRef}>
        <NavItem as={Link} to="/" isHidden={isNavItemHidden}>
          <StyledCloudIcon src={CloudIcon} alt="Magazyn" />
          <Paragraph>Magazyn</Paragraph>
        </NavItem>
        {title !== 'Zadania' && (
          <NavItem as={Link} to="/zadania" isHidden={isNavItemHidden}>
            <StyledAgendaIcon />
            <Paragraph>Zadania</Paragraph>
          </NavItem>
        )}
        {title !== 'Notatki' && (
          <NavItem as={Link} to="/notatki" isHidden={isNavItemHidden}>
            <StyledNotesIcon />
            <Paragraph>Notatki</Paragraph>
          </NavItem>
        )}
      </Nav>
      <PageTitle>
        {title === 'Notatki' && <StyledNotesIconBig />}
        {title === 'Zadania' && <StyledAgendaIconBig />}
        <Heading>{title}</Heading>
      </PageTitle>
      {additionalContent && <AdditionalContent>{additionalContent}</AdditionalContent>}
    </Wrapper>
  );
};

Topbar.propTypes = {
  favicon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  additionalContent: PropTypes.element,
};

Topbar.defaultProps = {
  additionalContent: null,
};

export default Topbar;
